<template>
  <el-dialog :visible.sync="openStatus" class="create-ssh-container"
             :title="$t('ssh.text.create')" :close-on-click-modal="false" v-if="dialogVisible"
             @close="doClose">
    <!-- 地域-->
    <el-form class="cps-create-form" label-width="130px" :model="ruleForm" ref="ruleForm"
             :rules="rules" @submit.native.prevent>
      <!--地域-->
      <el-form-item :label="$t('create.text.region') | withColon">
        <el-radio-group v-model="ruleForm.region">
          <el-radio-button v-for="(regionName,region,index) in regions" :key="index"
                           :label="region">{{regionName}}
          </el-radio-button>
        </el-radio-group>
        <el-tooltip effect="dark" style="margin-left:10px" placement="right">
          <div slot="content" class="my-create-tip">
            {{$t('create.tooltip.region')}}
          </div>
          <a><i class="jc-icon-question"></i></a>
        </el-tooltip>
        <br/>
        <div v-if="quotaFullUsed">
          <span class="ff0">{{$t('ssh.help.quotaFullUsed')}}</span>
          <a :href="Config.WORK_URL" target="_blank">
            {{$t('popHelper.text.submitSheet')}}
          </a>
          <span class="ff0">{{$t('ssh.help.increaseQuota')}}</span>
        </div>
      </el-form-item>
      <!--密钥对名称-->
      <el-form-item :label="$t('ssh.text.name') | withColon" prop="name" :show-message="false" required
                    ref="name">
        <el-input v-model="ruleForm.name" placeholder=""
                  @keyup.enter.native="doConfirm"
                  @blur="ruleFormTag.name = ValidOrErrorConstant.NONE"
                  @focus="focusName"></el-input>
        <p v-if="nameNull" class="el-form-item-help-error">
          {{$t('create.placeholder.nameNull')}}
        </p>
        <p v-if="!nameRepeated && !nameNull" class="el-form-item-name-help"
           :class="{'el-form-item-help-error': this.nameNotNullNotValidate === true}">
          {{$t('ssh.help.nameRule')}}
        </p>
        <p v-if="nameRepeated" class="el-form-item-name-help"
           :class="{'el-form-item-help-error': this.nameRepeated === true}">
          {{$t('ssh.help.nameSame')}}
        </p>
      </el-form-item>
      <!--创建方式-->
      <el-form-item :label="$t('ssh.text.createType') | withColon" prop="desc" :show-message="false"
                    ref="createType">
        <el-radio-group v-model="createType">
          <el-radio-button v-for="item in createTypes" :key="item.label"
                           :label="item.label">
            {{item.text}}
          </el-radio-button>
        </el-radio-group>
        <br/>
        <p v-if="createType === 'newPairs'" class="el-form-item-name-help">
          {{ $t('ssh.help.createTip') }}
        </p>
      </el-form-item>
      <!--输入公钥-->
      <el-form-item :label="$t('ssh.text.enterPublicKey') + ':'" prop="publicKey"
                    v-if="createType === 'existingPublicKeys'" ref="publicKey"
                    :show-message="false" required>
        <el-input v-model="ruleForm.publicKey" style="width:500px;"
                  :placeholder="$t('ssh.help.publicKeyPlaceholder')"
                  @blur="ruleFormTag.publicKey = ValidOrErrorConstant.NONE"
                  @focus="focusPublicKey" type="textarea"></el-input>
        <p v-if="publicKeyNull" class="el-form-item-help-error">
          {{$t('ssh.help.publicKeyNull')}}
        </p>
        <p v-if="publicNotValidate && !publicKeyNull" class="el-form-item-name-help"
           :class="{'el-form-item-help-error': this.publicNotValidate === true}">
          {{$t('ssh.help.publicKeyNotValid')}}
        </p>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="doClose">{{ $t('detail.text.cancel') }}</el-button>
      <el-button @click="doConfirm" type="primary" :disabled="quotaFullUsed">
        {{ $t('detail.text.sure')}}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {ServiceCodeConstant, ValidOrErrorConstant} from "@/common/Constants";

  export default {
    components: {},
    props: {
      dialogVisible: {
        type: Boolean,
        default: true,
      },
      currentRegion: {
        type: String,
        default: ''
      }
    },
    data() {
      const validateName = (rule, value, callback) => {
        var rule = /^[-0-9a-zA-Z_]{1,32}$/
        var result = rule.test(value)
        if (value === '') {
          callback(new Error(this.$t('create.placeholder.nameNull')));
        } else {
          if (!result) {
            callback(new Error(this.$t('ssh.help.publicKeyNotValid')));
          } else {
            this.checkNameRepeated().then(() => {
                if (this.nameRepeated) {
                  callback(new Error(this.$t('ssh.help.nameSame')));
                } else {
                  callback();
                }
              },
            );
          }
        }
      }
      const validatePublicKey = (rule, value, callback) => {
        if (value.trim() === '') {
          callback(new Error(this.$t('ssh.help.publicKeyNull')));
          this.ruleFormTag.publicKey = ValidOrErrorConstant.ERROR
          }else{
            callback();
          }
      };
      return {
        // 名称是否重复
        nameRepeated: false,
        // 密钥对创建方式
        createTypes: [
          {
            label: 'newPairs',
            text: this.$t('ssh.text.newParis')
          },
          {
            label: 'existingPublicKeys',
            text: this.$t('ssh.text.existingPublicKeys')
          }
        ],
        createType: 'newPairs',
        openStatus: this.dialogVisible,
        ruleForm: {
          region: this.currentRegion,
          name: '',
          publicKey: ''
        },
        ruleFormTag: {
          name: ValidOrErrorConstant.VALID,
          publicKey: ValidOrErrorConstant.VALID,
        },
        rules: {
          name: [
            {
              validator: validateName,
              trigger: 'blur'
            }
          ],
          publicKey: [
            {
              validator: validatePublicKey,
              trigger: 'blur'
            }
          ],
        },
        quotaNumber: 1,
        // 公钥不为空&&不满足验证
        publicNotValidate: false
      };
    },
    computed: {
      regions() {
        return this.$store.state.region.map
      },
      commonParams() {
        return {
          region: this.ruleForm.region,
          name: this.ruleForm.name
        }
      },
      ServiceCodeConstant: () => ServiceCodeConstant,
      ValidOrErrorConstant: () => ValidOrErrorConstant,
      // 名称是否为空
      nameNull() {
        return this.ruleFormTag.name !== ValidOrErrorConstant.VALID && this.ruleForm.name === ''
      },
      // 名称不为空&&不满足验证&&名称不重复
      nameNotNullNotValidate() {
        return !this.nameNull && this.ruleFormTag.name === ValidOrErrorConstant.ERROR
      },
      // 是否已经满额
      quotaFullUsed() {
        return this.quotaNumber <= 0;
      },
      // 公钥是否为空
      publicKeyNull(){
        return this.ruleFormTag.publicKey !== ValidOrErrorConstant.VALID
          && this.ruleForm.publicKey.trim() === ''
      },
    },
    mounted() {
      this.getQuota();
    },
    watch: {
      dialogVisible(val) {
        this.openStatus = val;
      },
      'ruleForm.region'(){
        this.getQuota()
      },
    },
    methods: {
      // focus名称输入框
      focusName() {
        this.ruleFormTag.name = ValidOrErrorConstant.VALID
      },
      // focus公钥输入框
      focusPublicKey(){
        this.ruleFormTag.publicKey = ValidOrErrorConstant.VALID
        this.publicNotValidate = false
      },
      // 验证名称是否重复
      async checkNameRepeated() {
        let params = {
          region: this.ruleForm.region,
          name: this.ruleForm.name,
        }
        const nameRepeated = await Ajax.get('/api/cps/checkKeypairName', params)
          .then((res) => {
            return res.data.success
          })
          .catch(async (err) => {
            const {response} = err.data;
            try {
              const json = await response.json();
              // this.$message.error(json.errmsg);
            } catch (ex) {
              console.log(ex);
            }
          })
          .finally(() => {
          })
        this.nameRepeated = nameRepeated
      },
      // 获取SSH quota
      getQuota() {
        const target = this;
        Ajax.get({
          url: '/api/bm',
          action: '/getUserQuotas',
          param: {
            serviceCode: ServiceCodeConstant.CPSSSH
          },
          success: (data) => {
            target.quotaNumber = data.userQuotas[target.ruleForm.region];
          },
          fail(data) {
          }
        });
      },
      // 关闭弹框
      doClose() {
        this.doReset('ruleForm');
        this.$emit('ifDialogVisible', false);
      },
      // 点击确认按钮
      doConfirm() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.createSSH();
          } else {
            this.ruleFormTag.name = this.$refs['name'].validateState
          }
        });
      },
      // 清空表单
      doReset(formName) {
        this.$refs[formName].resetFields();
        this.ruleFormTag.name = ValidOrErrorConstant.VALID;
      },
      // 创建密钥对
      createKeyPairs() {
        this.$refs['ruleForm'].validate((valid) => {
          if (!valid) {
            return false;
          } else {
            Ajax.put('/api/cps/keypairs', this.commonParams)
              .then((res) => {
                SSHPopHelper.alert(this);
                /**开始下载**/
                let blob = new Blob([res.data.privateKey], {
                  type: 'application/json;charset=utf-8'
                });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `${this.ruleForm.name}.pem`;
                link.click();
                this.$emit('refreshList');
                this.doClose();
              })
              .catch(async (err) => {
                const {response} = err.data;
                try {
                  const json = await response.json();
                  this.$message.error(json.errmsg);
                } catch (ex) {
                  console.log(ex);
                }
              })
              .finally(() => {
                this.doClose();
              });
          }
        })
      },
      // 导入秘钥对
      importKeyPairs() {
        const params = Object.assign(this.commonParams, {publicKey: this.ruleForm.publicKey})
        Ajax.put('/api/cps/importKeypairs', params)
          .then(() => {
            this.$emit('refreshList');
            this.doClose();
          })
          .catch(async (err) => {
            const {response} = err.data;
            try {
              const json = await response.json();
              if(json.errno === 20101){
                this.$refs['publicKey'].validateState = ValidOrErrorConstant.ERROR
                this.publicNotValidate = true
                this.ruleFormTag.publicKey = ValidOrErrorConstant.ERROR
                return false;
              }
              this.$message.error(json.errmsg);
            } catch (ex) {
              console.log(ex);
            }
          })
          .finally(() => {
            if(!this.publicNotValidate){
              this.doClose();
            }
          });
      },
      // 调用创建SSH接口
      createSSH() {
        switch (this.createType) {
          case 'newPairs': {
            this.createKeyPairs()
            break;
          }
          case 'existingPublicKeys': {
            this.importKeyPairs();
            break
          }
          default:
        }
      },
    },
    created() {
    }
  };
</script>

<style lang="scss">
  @import '../../../assets/scss/createCommon';
  @import 'style';
</style>



// WEBPACK FOOTER //
// src/components/ssh/create/Create.vue